import React from 'react'
import PropTypes from 'prop-types'

import { Avatar } from '../../Common'

export const MessageSystem = ({ type, text, className, masked = false }) => (
  <React.Fragment>
    <Avatar type={type} agentName={text} />
    <div
      className={`${className('body')}${masked ? ' sessioncamhidetext' : ''}`}
      dangerouslySetInnerHTML={{ __html: `${text}` }}
    />
  </React.Fragment>
)

MessageSystem.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  className: PropTypes.func.isRequired,
  masked: PropTypes.bool,
}

export default MessageSystem
